/* eslint-disable react/require-default-props */

import React, { useMemo, useState } from "react";
import TimelineSegmentItineraries from "./TimelineSegmentItineraries";
import CustomPoiModal from "../../../components/CustomPoiModal/CustomPoiModal";
import usePlan from "../../../hooks/usePlan";
import { TimelineSegmentGroup } from "../../../utils/timelineAdapters";
import classes from "../../TripPlan/layouts/TripLayout/Container/PlanContiner/PlanContainer.module.scss";

interface ITimelinePlanContainer {
  show: boolean;
  alternativesStepId?: number;
  setAlternativesStepId: (stepId?: number) => void;
  gygTourIds: number[];
  bbTourIds: number[];
  viatorTourIds: string[];
  toristyTourIds: string[];
  toursLoading: boolean;
  setShowCloneModal: (show: boolean) => void;
  onBookingClick: () => void;
  // Timeline specific props - segment-based grouping
  segmentGroups: TimelineSegmentGroup[];
  // Active segment index for map display (expanded segment)
  activeSegmentIndex: number | null;
  setActiveSegmentIndex: (index: number | null) => void;
  // Segment delete handler
  onSegmentDelete: (segmentIndex: number) => void;
}

const TimelinePlanContainer: React.FC<ITimelinePlanContainer> = ({
  show,
  alternativesStepId,
  setAlternativesStepId,
  gygTourIds,
  bbTourIds,
  viatorTourIds,
  toristyTourIds,
  toursLoading,
  setShowCloneModal,
  onBookingClick,
  segmentGroups,
  activeSegmentIndex,
  setActiveSegmentIndex,
  onSegmentDelete,
}) => {
  const { plans } = usePlan();
  const [showCustomPoiModal, setShowCustomPoiModal] = useState<boolean>(false);
  const [selectedDayIndex, setSelectedDayIndex] = useState<number>(0);

  const plansIdDate = useMemo(
    () => plans?.map(p => ({ id: p.id, date: p.date })) || [],
    [plans]
  );

  const planContainerClasses = [classes.planContainer];
  if (!window.tconfig.SHOW_OVERVIEW)
    planContainerClasses.push("trip-layout-container-height");
  else planContainerClasses.push("trip-layout-container-height-tab");
  if (show) planContainerClasses.push(classes.planContainerOpen);
  else planContainerClasses.push(classes.planContainerClose);

  return (
    <>
      <div className={planContainerClasses.join(" ")}>
        <TimelineSegmentItineraries
          segmentGroups={segmentGroups}
          plans={plans}
          alternativesStepId={alternativesStepId}
          setAlternativesStepId={setAlternativesStepId}
          customPoiModalShow={(segmentIndex) => {
            setSelectedDayIndex(segmentIndex);
            setShowCustomPoiModal(true);
          }}
          gygTourIds={gygTourIds}
          bbTourIds={bbTourIds}
          viatorTourIds={viatorTourIds}
          toristyTourIds={toristyTourIds}
          toursLoading={toursLoading}
          setShowCloneModal={setShowCloneModal}
          onBookingClick={onBookingClick}
          activeSegmentIndex={activeSegmentIndex}
          onSegmentToggle={setActiveSegmentIndex}
          onSegmentDelete={onSegmentDelete}
        />
      </div>

      <CustomPoiModal
        dayIndex={selectedDayIndex}
        plansIdDate={plansIdDate}
        showModal={showCustomPoiModal}
        setShowModal={() => setShowCustomPoiModal(!showCustomPoiModal)}
        isTimeline={true}
      />
    </>
  );
};

export default TimelinePlanContainer;
